<div *ngIf="userType == 'investor'"><nz-input-group nzPrefixIcon="search" class="search-dropdown">
    <!-- (nzOnSearch)="searchInvestor($event)" nzServerSearch [nzDropdownRender]="renderTemplate"-->
    <nz-select nzShowSearch [nzDropdownClassName]="'disable-dropdown'" nzPlaceHolder="Search in Database..."
      [(ngModel)]="inputValue" class=" hideArrow" [nzOpen]="isOpenDropdown" (nzFocus)="isOpenDropdown = true"
      (nzOnSearch)="searchInvestor($event)" nzServerSearch [nzNotFoundContent]="renderTemplate">
      <ng-template></ng-template>
      <ng-container *ngFor="let investor of investorsDBList">
        <nz-option *ngIf="!isLoading" [nzLabel]="investor.investorDisplayName" nzCustomContent [nzValue]="investor._id"
          nzDisabled>
          <span class="d-flex justify-content-space-between w-70"><span class="ellipsis-text">{{investor.companyName + '
              | ' + investor.investorDisplayName}}</span>
            <span *ngIf="siteDetails?.NonAlcStatus && investor.isNonAlc" class="program-box m-0 w-55"> Non-alc
            </span></span> <button nz-button nzType="primary" class="btn-option" (click)="addInvestorToList(investor)"
            [disabled]="investor.isAlreadyAdded || investor._id == currentAddingInvestor?._id"
            [nzLoading]="isDeletingInvestor && investor._id == currentAddingInvestor._id">
            {{!investor.isAlreadyAdded ? 'Add' : 'Added'}}
          </button></nz-option>
      </ng-container>
      <nz-option *ngIf="isLoading" nzCustomContent nzDisabled>
        <span nz-icon nzType="loading" class="loading-icon"></span>
        Loading Data...
      </nz-option>
      <ng-template #renderTemplate>
        <span>No investor found with the searched name. Create a New One!</span>
        <span *ngIf="!isLoading">
          <!-- && investorsDBList?.length == 0 -->
          <a class="create-new-ivestor-btn" (click)="showInvestorModal()"><i nz-icon
              nzType="plus" nzTheme="outline"></i>Create New Investor</a>
        </span>
      </ng-template>
    </nz-select>
  </nz-input-group>
</div>
<nz-modal nzClassName="investorModal investor-modal-box-main" [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false" [nzWidth]="850" nzCentered [nzVisible]="isVisibleInvestorDrawer"
  [nzTitle]="'Create New Investor'" [nzFooter]="null" (nzOnCancel)="hideInvestorDrawer(null)">
  <ng-container *nzModalContent>
    <app-add-investor-form (investorData)="hideInvestorDrawer($event)"></app-add-investor-form>
  </ng-container>
</nz-modal>
